import type { Observable } from 'rxjs';

import { Injectable, signal, type WritableSignal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
    providedIn: 'root',
})
export class AuthContext {
    readonly isTokenValid: WritableSignal<boolean> = signal(false);
    readonly isTokenValid$: Observable<boolean> = toObservable(this.isTokenValid);
}
